import React from 'react';
var TutorialWalkthroughButton = function (props) {
    var setQBRenderFlag = props.setQBRenderFlag;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", onClick: function () {
                setQBRenderFlag('walkthrough');
            } }, "Tutorial Walkthrough")));
};
export default TutorialWalkthroughButton;
